<template>
  <div class="min-h-screen" :class="[`bg-${$route.meta.background}`]">
    <nav class="main-nav">
      <Burger></Burger>
    </nav>
    <Sidebar></Sidebar>
    <MobileMenu></MobileMenu>
    <transition
      name="zoom"
      mode="out-in"
      v-on:before-enter="beforeEnter"
      v-on:leave="leave"
    >
      <router-view />
    </transition>
    <Classes v-if="isClassListVisible" />
  </div>
</template>

<script>
import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';
import Burger from '@/components/Burger.vue';
import Sidebar from '@/components/Sidebar/Sidebar.vue';
import MobileMenu from '@/components/MobileMenu.vue';

import Classes from '@/components/Classes/Classes.vue';

export default {
  name: 'MainLayout',
  data() {
    return {
      showSlider: true,
    };
  },
  components: {
    Burger,
    Sidebar,
    MobileMenu,
    Classes,
  },

  computed: {
    ...mapState('layout', ['isLoading', 'isClassListVisible']),
    ...mapGetters('auth', ['isFullAccess']),
  },

  methods: {
    ...mapActions('lessons', ['clearLesson', 'clearLessons']),
    ...mapActions('homeworks', ['clearHomeworks']),
    ...mapActions('grades', ['clearGrades']),
    ...mapActions('students', ['clearStudent', 'clearStudents']),
    ...mapActions('attendances', ['clearAttendances']),
    ...mapMutations('layout', ['showClassList', 'hideClassList']),

    beforeEnter() {
      this.showSlider = true;
    },

    leave(__, done) {
      this.showSlider = false;
      done();
    },

    clearStore() {
      this.clearLesson();
      this.clearLessons();
      this.clearHomeworks();
      this.clearGrades();
      this.clearAttendances();
    },
  },

  created() {
    this.$store.commit('layout/startLoading');
  },

  mounted() {
    setTimeout(() => {
      this.$store.commit('layout/finishLoading');
    }, 1000);
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'Main.HomeworksDetails'
    || to.name === 'Auth.ChangePassword'
    || to.name === 'Regulations.PrivacyPolicy'
    || to.name === 'Regulations.Regulation') {
      next();
    } else {
      this.clearStore();
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.main-nav {
  @apply absolute p-2;
  z-index: 2;
  left: 16px;
  top: 38px;
}
</style>

<style lang="scss">
.shepherd-enabled.shepherd-element {
  opacity: 0;
  @media screen and (min-width: 992px) {
    opacity: 1;
  }
}

.shepherd-modal-overlay-container.shepherd-modal-is-visible {
  opacity: .6;
}

.shepherd-arrow {
  @apply hidden;
}

.stepherd-custom-arrow--top {
  @apply absolute hidden;
  bottom: -56px;
  left: -174px;
  @media screen and (min-width: 1200px) {
    @apply block;
  }
}

.stepherd-custom-arrow--bottom {
  @apply absolute hidden;
  bottom: -170px;
  left: -100px;
  @media screen and (min-width: 1200px) {
    @apply block;
  }
}

.stepherd-custom-arrow--left {
  @apply absolute hidden;
  top: -116px;
  right: -50%;
  transform: translateX(calc(-50% + 50px));
  @media screen and (min-width: 1200px) {
    @apply block;
  }
}

.stepherd-custom-arrow--right {
  @apply absolute hidden;
  bottom: 20px;
  left: -220px;
  @media screen and (min-width: 1200px) {
    @apply block;
  }
}

.shepherd-element {
  /* box-shadow: -32px 3px 36px #0000001C; */
  @media screen and (min-width: 992px) {
    @apply px-6 pt-4 pb-12;
    border-radius: 20px;
    max-width: 325px;
    box-shadow: none;
  }
}

.shepherd-content {
  font-family: "GT Walsheim Pro", sans-serif;
}

.shepherd-header {
  @apply p-0;
  button {
    @apply px-2;
  }
}

.shepherd-cancel-icon {
  @apply text-transparent;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-image: url("~@/assets/images/onboarding/close.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.shepherd-text {
  @apply text-black leading-normal p-0;
  h3 {
    @apply font-bold text-lg pb-3;
    line-height: 26px;
    @media screen and (min-width: 768px) {
      @apply text-2xl;
    }
  }
  p {
    @apply text-base p-0 pb-3;
    line-height: 18px;
    &:last-child {
      @apply pb-8;
    }
  }
  img {
    @apply block mb-8;
  }
}

.shepherd-footer {
  @apply justify-center p-0;
}

.shepherd-button {
  @apply block bg-pink-main text-white text-lg px-6 py-0 cursor-pointer font-bold;
  border-radius: 100px;
  line-height: 40px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    @apply bg-pink-dark-main text-white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
  &:not(:disabled):hover {
    @apply text-white bg-pink-dark-main;
  }
}
.shepherd-button:only-child {
  @apply px-12;
}

.shepherd-enabled .shepherd-target {
  overflow: hidden;
}
</style>
